import { connect } from 'react-redux'
import * as action from '../../state/detail/action'
import * as selector from '../../state/detail/selector';
import ProcessInstanceList from '../../../customer/component/detail/ProcessInstanceList';

const mapStateToProps = (state, props) => {
    return {
        processInstanceList: selector.selectProcessList(state),
        customerId: selector.selectCustomerId(state)
    }
}

const mapDispatchToProps = {
    findProcessComment: action.findProcessComment,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProcessInstanceList)



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/ProcessListCommentWidgetContainer.js